import tw from 'twin.macro';

import { Loader } from './Loader';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
}

const Button = ({ isLoading = false, children, ...props }: ButtonProps): JSX.Element => (
  <button tabIndex={0} {...props}>
    {isLoading ? <Loader size='sm' theme='dark' /> : children}
  </button>
);

Button.displayName = 'Button';

Button.Primary = tw(
  Button
)`w-full h-[45px] bg-accent-2 rounded-md text-text-and-icon-invert fill-current [> .loading-spinner]:(border-accent-2 border-b-transparent)`;

Button.Secondary = tw(
  Button
)`w-full h-[45px] bg-primary rounded-md text-accent [> .loading-spinner]:(border-accent border-b-transparent)`;

export { Button };
export type { ButtonProps };
